import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Collapsible panel used for thinking blocks and tool calls.
//
// The header shows an icon (per kind), a label, an optional sub-line
// preview, the duration, and a status chip. Clicking the header toggles
// the body.
import { useState } from "react";
import { Icon } from "./icons.js";
const KIND_ICON = {
    think: Icon.brain,
    search: Icon.search,
    web: Icon.web,
    file: Icon.file,
    edit: Icon.pencil,
    terminal: Icon.terminal,
    bash: Icon.bash,
    code: Icon.terminal,
    devtools: Icon.devtools,
    browser: Icon.browser,
    network: Icon.network,
    db: Icon.db,
    tool: Icon.tool,
};
export function Expandable({ kind = "think", label, sub, duration, status = "done", defaultOpen = false, children, }) {
    const [open, setOpen] = useState(defaultOpen);
    const IconC = KIND_ICON[kind] ?? Icon.tool;
    return (_jsxs("div", { className: "exp", "data-open": open ? "true" : "false", "data-status": status, children: [_jsxs("div", { className: "exp__head", onClick: () => setOpen(!open), children: [_jsx("span", { className: "exp__chev", children: _jsx(Icon.chev, {}) }), _jsx("span", { className: "exp__icon", children: status === "running" ? (_jsx("span", { className: "exp__spin" })) : status === "error" ? (_jsx(Icon.warn, {})) : (_jsx(IconC, {})) }), _jsx("span", { className: "exp__label", children: label }), sub && _jsx("span", { className: "exp__sub", children: sub }), status === "error" && _jsx("span", { className: "exp__status exp__status--err", children: "failed" }), status === "running" && _jsx("span", { className: "exp__status exp__status--run", children: "running" }), duration && _jsx("span", { className: "exp__dur", children: duration })] }), _jsx("div", { className: "exp__body", children: children })] }));
}
//# sourceMappingURL=Expandable.js.map